import { useTranslation } from 'react-i18next'

import { Divider } from '@chakra-ui/react'

import CloseIcon from '@wwt/shared/assets/icons/outline/close.svg'
import { CountdownTimer } from '@wwt/ui/components'

import { Button } from '@/shared/ui/Button.tsx'

export interface NotificationAggregationProps {
	onClose: () => void
	count: number
}

const NotificationAggregation = ({
	onClose,
	count
}: NotificationAggregationProps) => {
	const { t } = useTranslation('notification-popup')
	return (
		<>
			<div className="mb-3 flex justify-between">
				<p className="text-lg">{t('aggregation.name')}</p>
				<div className="h-6 w-6">
					<CloseIcon
						className="hover:text-brand-200 h-6 w-6 cursor-pointer"
						onClick={onClose}
					/>
				</div>
			</div>
			<Divider />
			<p className="mt-3 mb-4 text-base">
				{t('aggregation.description', { count })}
			</p>
			<div className="flex items-center gap-2">
				<CountdownTimer
					max={5}
					isStopped={false}
				/>
				<Button
					className="w-full"
					size="sm"
				>
					{t('aggregation.buttonText')}
				</Button>
			</div>
		</>
	)
}

export default NotificationAggregation
